var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewAvatar = function SvgNewAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M1 18.143A5.143 5.143 0 0 1 6.143 13h5.714A5.143 5.143 0 0 1 17 18.143a.857.857 0 0 1-.857.857H1.857A.857.857 0 0 1 1 18.143M13.25 5.25a4.25 4.25 0 1 1-8.5 0 4.25 4.25 0 0 1 8.5 0"
  })));
};
export default SvgNewAvatar;